import { api } from "api/api";
import { AxiosError } from "axios";
import Indicador from "model/indicadores/Indicador";
import { IndicadorColeta } from "model/indicadores/IndicadorColeta";
import IndicadorDashboardItem from "model/indicadores/IndicadorDashboardItem";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";

class IndicadorColetaService implements BaseServiceCadastros<IndicadorColeta> {
    pesquisar(page: Pageable, filter?: DataTableFilterMeta, idConta?: number | null): Promise<Page> {
        throw new Error("Method not implemented.");
    }
    consultar(id: number | string, idConta?: number | null): Promise<IndicadorColeta> {
        throw new Error("Method not implemented.");
    }

    incluir(indicadorColeta: IndicadorColeta) {
        return new Promise<IndicadorColeta>((resolve, reject): void => {
            let url = `/indicadorColeta/incluir`;
            api
                .post(url, JSON.stringify(indicadorColeta))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(indicadorColeta: IndicadorColeta) {
        return new Promise<IndicadorColeta>((resolve, reject): void => {
            api
                .put(`/indicadorColeta/editar`, JSON.stringify(indicadorColeta))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number | string, idConta?: number | null): Promise<void> {
        throw new Error("Method not implemented.");
    }

    buscarPorIndicador(idIndicador: number) {
        return new Promise<Indicador>((resolve, reject): void => {
            api
                .get(`/indicadorColeta/indicador/${idIndicador}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    prepararProximaColeta(idIndicador: number) {
        return new Promise<IndicadorDashboardItem>((resolve, reject): void => {
            api
                .get(`/indicadorColeta/proxima-coleta/${idIndicador}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default IndicadorColetaService;